import {
  getEls,
  hasClass,
  addClass,
  removeClass,
  activateSubmenuOverlay,
  deactivateSubmenuOverlay,
} from "./helpers.js";

var EventHandlers = new Object();

// Idle timer — only deactivate overlay after user stops interacting
EventHandlers._idleTimer = null;
EventHandlers._idleDelay = 150;

function resetIdleTimer() {
  if (EventHandlers._idleTimer) {
    clearTimeout(EventHandlers._idleTimer);
    EventHandlers._idleTimer = null;
  }
}

function startIdleTimer() {
  resetIdleTimer();
  EventHandlers._idleTimer = setTimeout(function () {
    deactivateSubmenuOverlay();
    EventHandlers._idleTimer = null;
  }, EventHandlers._idleDelay);
}

EventHandlers.MenuItem = new Object();

EventHandlers.MenuItem.mouseenter = function (event, el) {
  resetIdleTimer();

  var elSubmenuSection = el.querySelector(".submenu-section");

  if (elSubmenuSection) {
    activateSubmenuOverlay();
  }
};

EventHandlers.MenuItem.mouseleave = function (event, el) {
  var relatedTarget = event.relatedTarget;

  if (relatedTarget && el.contains(relatedTarget)) return;
  if (relatedTarget && relatedTarget.closest("ul.main-menu > .menu-item")) return;

  startIdleTimer();
};

EventHandlers.MenuItem.parentClick = function (event, el) {
  if (typeof helpers !== "undefined" && helpers.shouldDebug("headerSection")) {
    console.log(
      "[HeaderSection.EventHandlers] parentClick href:",
      $(el).find(".menu-link").first().attr("href"),
    );
    console.log(
      "[HeaderSection.EventHandlers] parentClick submenu:",
      event.target.closest(".submenu-section"),
    );
  }
  let parent_link = $(el).find(".menu-link").first().attr("href");
  if (parent_link === "#" && event.target.closest(".submenu-section") == undefined) {
    event.preventDefault();
  }
};

EventHandlers.submenuMouseleave = function (event) {
  var relatedTarget = event.relatedTarget;

  if (relatedTarget && relatedTarget.closest("ul.main-menu")) return;

  startIdleTimer();
};

EventHandlers.windowScroll = function () {
  const { elMain, elTopSection } = getEls();
  // Bail when the header markup isn't on this page (e.g. legacy/blank templates).
  if (!elMain || !elTopSection) return;
  const scrollY = window.scrollY || window.pageYOffset;
  const maxHeight = elTopSection.offsetHeight;

  const S =
    EventHandlers.windowScroll._s ||
    (EventHandlers.windowScroll._s = {
      lastScrollY: scrollY,
      current: 0,
      target: 0,
      raf: null,
    });

  const scrollDelta = scrollY - S.lastScrollY;
  S.lastScrollY = scrollY;

  S.target = Math.min(Math.max(S.target + scrollDelta, 0), maxHeight);

  if (!S.raf) {
    const step = () => {
      const alpha = 0.2;
      S.current += (S.target - S.current) * alpha;

      if (Math.abs(S.target - S.current) < 0.3) {
        S.current = S.target;
      }

      elMain.style.setProperty("--top-section-height", `-${S.current}px`);

      if (S.current !== S.target) {
        S.raf = requestAnimationFrame(step);
      } else {
        S.raf = null;
      }
    };
    S.raf = requestAnimationFrame(step);
  }
};

EventHandlers.Mobile = new Object();

EventHandlers.Mobile.togglerClick = function (event, el) {
  const { elMobileMenu } = getEls();

  if (hasClass(elMobileMenu, "d-none")) {
    removeClass(elMobileMenu, "d-none");
    el.setAttribute("data-icon", "close");
  } else {
    addClass(elMobileMenu, "d-none");
    el.setAttribute("data-icon", "hamburger");
  }
};

EventHandlers.Mobile.toggleSubmenu = function (event) {
  var el = event.target;
  var { elMobileSubmenus } = getEls();
  var elSubmenu = el.closest(".menu-item").querySelector(".submenu-section");

  if (hasClass(elSubmenu, "active")) {
    removeClass(elMobileSubmenus, "active");
  } else {
    removeClass(elMobileSubmenus, "active");
    addClass(elSubmenu, "active");
  }
};

export default EventHandlers;
